import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Flex, Box } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

import WideContainer from '../../components/WideContainer/WideContainer';
import { TypographyContextProvider } from '../../components/Typography/Typography';

import colourMatching from '../../utils/colourMatching';
import isFadeEnabled from '../../utils/isFadeEnabled';
import ColouredButton from '../../components/Button/Button';
import { theme } from '../../styles/theme';
import { PortfolioSectorSectionStoryblok } from '../../types/storyblok';
import { PortfolioCard } from '../../components/PortfolioCard/PortfolioCard';
import { Type } from '../../base/Type/Type';

const StartupsContainer = ({
  startups,
  colourScheme,
}: PortfolioSectorSectionStoryblok) => {
  const [page, setLoadMore] = useState(1);
  const limit =
    typeof window !== 'undefined' &&
    window.innerWidth <= parseInt(theme.breakpoint.md)
      ? 15
      : 30;
  const filteredStartups = startups.slice(0, limit * page);

  return (
    <TypographyContextProvider value={{ colourScheme }}>
      <Box
        as="section"
        className="repeating-border-section"
        px={[3, 4]}
        py={[4, , 0]}
        backgroundColor={colourMatching(colourScheme)}
      >
        <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
          <Scene classToggle="full-opacity">
            <WideContainer className={isFadeEnabled() ? 'zero-opacity' : ''}>
              <Flex className="bottom-border" flexWrap="wrap" mx={[0, 0, -2]}>
                <Box
                  px={[0, 2]}
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Box
                    as="div"
                    className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-10 gap-x-8"
                  >
                    {filteredStartups.map((startup: any, i: number) => (
                      <PortfolioCard key={i} {...startup} />
                    ))}
                  </Box>
                  {startups.length > page * limit && (
                    <ColouredButton
                      onClick={() => setLoadMore(page + 1)}
                      className="mt-10 flex items-center justify-between !px-[1.5em] !py-[0.51em] !text-[1rem]"
                      variant="primary"
                    >
                      <Type as="p" className="text-p1">
                        More
                      </Type>
                    </ColouredButton>
                  )}
                </Box>
              </Flex>
            </WideContainer>
          </Scene>
        </Controller>
      </Box>
    </TypographyContextProvider>
  );
};

const PortfolioSectorStartups = (props) => {
  const data = useStaticQuery(graphql`
    {
      records: allAirtable(
        filter: {
          table: { eq: "Master Companies" }
          data: {
            Logo: { raw: { elemMatch: { type: { ne: "image/svg+xml" } } } }
          }
        }
        sort: { data: { Company_Name: ASC } }
      ) {
        nodes {
          data {
            name: Company_Name
            sectors: _Program__Sector
            location: HQ__Country_
            link: Website_
            description: Description
            logo: Logo {
              images: localFiles {
                childImageSharp {
                  gatsbyImageData(height: 64, placeholder: NONE)
                }
              }
            }
          }
        }
      }
    }
  `);
  const nodes = data.records.nodes
    .map((i) => ({ sector: i.data.sectors[0].toLowerCase(), ...i.data }))
    .filter((i) => (props.location ? props.location == i.location : true))
    .filter((i) => (props.sector ? props.sector == i.sector : true));
  return <StartupsContainer startups={nodes} {...props} />;
};

export default PortfolioSectorStartups;
